<template>
  <div>
    <notifications group="foo" />
    <!--begin::Content header-->
    <div
      class="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10"
    ></div>
    <!--end::Content header-->

    <!--begin::Signin-->
    <div class="login-form login-signin" style="min-width: 500px" id="page">
      <div class="text-center mb-10 mb-lg-20">
        <h3 class="font-size-h1">Réinitialisation du mot de passe</h3>
        <p class="text-muted font-weight-semi-bold">
          Taper le code envoyé à <b>{{ email }}</b>
        </p>
      </div>

      <!--begin::Form-->
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div
          role="alert"
          v-bind:class="{ show: errors.length }"
          class="alert fade alert-danger"
        >
          <div class="alert-text" v-for="(error, i) in errors" :key="i">
            {{ error }}
          </div>
        </div>

        <b-form-group
          id="example-input-group-1"
          label=""
          label-for="example-input-1"
        >
          <b-form-input
            placeholder="Code"
            class="form-control form-control-solid h-auto py-5 px-6"
            id="example-input-1"
            name="example-input-1"
            v-model="$v.form.code.$model"
            :state="validateState('code')"
            aria-describedby="input-1-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">
            Code requis.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          id="example-input-group-2"
          label=""
          label-for="example-input-2"
        >
          <b-form-input
            placeholder="Nouveau mot de passe"
            class="form-control form-control-solid h-auto py-5 px-6"
            type="password"
            id="example-input-2"
            name="example-input-2"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">
            Min. 6 caractères, 1 lettre majuscule, 1 lettre minuscule, 1 chiffre
            et 1 caractère spécial
          </b-form-invalid-feedback>
        </b-form-group>

        <!--begin::Action-->
        <div
          class="form-group d-flex flex-wrap justify-content-between align-items-center"
        >
          <button
            ref="kt_resent_code"
            class="btn btn-info font-weight-bold px-9 py-4 my-3 font-size-3"
            type="button"
            @click="resendCode()"
          >
            Renvoyer le code
          </button>
          <button
            ref="kt_login_signin_submit"
            class="btn btn-primary font-weight-bold px-9 py-4 my-3 font-size-3"
          >
            Valider
          </button>
        </div>
        <!--end::Action-->
      </b-form>
      <!--end::Form-->
    </div>
    <!--end::Signin-->
  </div>
</template>

<style lang="scss" scoped>
.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>

<script>
//import { mapState } from "vuex";
//import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";

//import { SELECT_PHARMACY } from "../../../core/services/store/pharmacy.module";

//import UserService from "../../../services/user.service";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import AuthService from "../../../services/auth.service";
import { helpers } from "vuelidate/lib/validators";
const pw = helpers.regex(
  "alpha",
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{6,}$/
);

export default {
  mixins: [validationMixin],
  name: "resetpassword",
  data() {
    return {
      errors: [],
      email: this.$route.query.email,
      form: {
        code: "",
        password: "",
      },
    };
  },
  validations: {
    form: {
      code: {
        required,
      },
      password: {
        required,
        pw,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        email: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      const code = this.$v.form.code.$model;
      const password = this.$v.form.password.$model;

      AuthService.resetPassword({
        email: this.email,
        code: code,
        password: password,
      })
        .then((result) => {
          if (result.data) {
            this.$router.push({ name: "login" });
            this.$notify({
              group: "foo",
              title: "Succés",
              text: "Mot de passe réinitialisé avec succès.",
              type: "success",
            });
          } else {
            this.$notify({
              group: "foo",
              title: "Erreur",
              text: "Code incorrect.",
              type: "error",
            });
          }

          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        })
        .catch(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
    resendCode() {

      const resendButton = this.$refs["kt_resent_code"];
      resendButton.classList.add("spinner", "spinner-light", "spinner-right");

      AuthService.sendForgotPasswordCode(this.email)
        .then((result) => {
          switch (result.data.state) {
            case 1:
            case 4:
             this.$notify({
                group: "foo",
                title: "Succés",
                text:
                  "Code envoyé avec succés.",
                type: "success",
              });
              break;
            case 2:
              this.$notify({
                group: "foo",
                title: "Erreur",
                text:
                  "Trop de demandes, merci de réessayer dans quelques minutes.",
                type: "danger",
              });
              break;
            default:
          }

          resendButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        })
        .catch(() => {
          resendButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },
  },
  computed: {
    // ...mapState({
    //   errors: (state) => state.auth.errors,
    // }),
  },
};
</script>
